import { Tooltip as AntdTooltip } from "antd";
import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const Tooltip = ({ children, classname, ...rest }) => {
  return (
    <AntdTooltip {...rest} overlayClassName={classNames(styles.container, classname)}>
      {children}
    </AntdTooltip>
  );
};

export default Tooltip;
